import { render, staticRenderFns } from "./BaseH5.vue?vue&type=template&id=31cde535&"
import script from "./BaseH5.vue?vue&type=script&lang=js&"
export * from "./BaseH5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports